import { StyledDatePicker } from 'components/elements/DatePicker/DatePicker.styled';
import { StyledInput } from 'components/elements/Input/Input.styled';
import { StyledSelect } from 'components/elements/Select/Select.styled';
import { css, styled } from 'styles';
import { StyledFormFieldLabelProps, StyledFormFieldProps } from './types';

export const FormFieldError = styled.div`
  color: ${({ theme }) => theme.form.error};
  cursor: default;
  font-size: 0.9em;
  grid-area: error;
  margin-top: ${({ theme }) => theme.spacing.absolute.tiny};
`;

export const FormFieldInput = styled.div`
  grid-area: input;
  min-width: 0;

  ${StyledDatePicker},
  ${StyledInput},
  ${StyledSelect} {
    width: 100%;
  }
`;

export const FormFieldLabel = styled.div<StyledFormFieldLabelProps>`
  align-items: center;
  display: flex;
  font-size: 0.95em;
  font-weight: 600;
  grid-area: label;
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
`;

const verticalStyles = css`
  grid-template-areas:
    'label'
    'input'
    'error';
  grid-template-columns: 1fr;
  grid-template-rows: auto auto 1fr;

  ${FormFieldLabel} {
    margin: 0 0 ${({ theme }) => theme.spacing.absolute.tiny} 0;
    width: 100%;
  }
`;

const horizontalStyles = css`
  grid-template-areas:
    'label input'
    '. error';
  grid-template-columns: 15rem auto;

  @media (max-width: 576px) {
    ${verticalStyles};

    ${FormFieldLabel} {
      margin: 0 0 ${({ theme }) => theme.spacing.absolute.tiny} 0;
      width: 100%;
    }
  }
`;

export const StyledFormField = styled.div<StyledFormFieldProps>`
  display: grid;
  user-select: none;
  width: 100%;

  ${({ $vertical }) => ($vertical ? verticalStyles : horizontalStyles)};
`;

FormFieldError.displayName = 'FormFieldError';
FormFieldInput.displayName = 'FormFieldInput';
FormFieldLabel.displayName = 'FormFieldLabel';
StyledFormField.displayName = 'FormField.Styled';
